// Mostly used when positioning bones to see the associated weight painting
export enum ModelPreviewDisplay {
  Textured = 'textured',
  WeightPainted = 'weight-painted'
}
